
import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";

import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import dayjs from "dayjs";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { orangeTheme } from "../components/theme";
import Editor from 'react-simple-wysiwyg';
import Select from 'react-select';
import Loader from "../components/loader";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuid } from 'uuid';
import { Uploader } from "../utils/upload"
import SessionPopup from "./SessionPopup"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import OpenSeadragon from "openseadragon";
import rotateIconorange from "../assets/images/rotate_right-1.svg"


import progessIcon from "../assets/images/gifs/process-icon.gif";
import loadingIcon from "../assets/images/gifs/uploading-icon.gif";
import doneIcon from "../assets/images/icons/upload-done.png";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import FileUploadChecker from "../components/FileUploadChecker";

// Helper to read image dimensions, supporting TIFF


import { fromBlob, fromArrayBuffer } from "geotiff";

async function getGeoTiffDimensions(file) {
    let width = 0, height = 0;
    const validTiffExt = [".tif", ".tiff"];
    const validImgExt = [".jpg", ".jpeg", ".png"];

    try {
        if (file instanceof Blob) {
            const name = file.name?.toLowerCase() || "";

            if (validTiffExt.some(ext => name.endsWith(ext))) {
                // --- TIFF / GeoTIFF ---
                const tiff = await fromBlob(file);
                const image = await tiff.getImage(); // first IFD
                width = image.getWidth();
                height = image.getHeight();

            } else if (validImgExt.some(ext => name.endsWith(ext))) {
                // --- JPG / PNG ---
                const img = await blobToImage(file);
                width = img.width;
                height = img.height;

            } else {
                throw new Error("Unsupported file type");
            }

        } else if (typeof file === "string") {
            const lower = file.toLowerCase();

            if (validTiffExt.some(ext => lower.endsWith(ext))) {
                // --- TIFF from URL ---
                const res = await fetch(file);
                if (!res.ok) throw new Error("Failed to fetch TIFF");
                const arrayBuffer = await res.arrayBuffer();
                const tiff = await fromArrayBuffer(arrayBuffer);
                const image = await tiff.getImage();
                width = image.getWidth();
                height = image.getHeight();

            } else if (validImgExt.some(ext => lower.endsWith(ext))) {
                // --- JPG / PNG from URL ---
                const img = await urlToImage(file);
                width = img.width;
                height = img.height;

            } else {
                throw new Error("Unsupported URL type");
            }
        }

        return {
            width,
            height,
            resolution: width * height,
        };
    } catch (err) {
        console.error("Error reading image:", err);
        throw new Error("Could not read image dimensions");
    }
}

// Helpers
function blobToImage(blob) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
            resolve(img);
            URL.revokeObjectURL(url);
        };
        img.onerror = reject;
        img.src = url;
    });
}

function urlToImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // may need proper CORS headers
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
}







let { lambda, country, appname } = window.app;
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};
const customComponents = {
    DropdownIndicator: () => null, // Remove the dropdown indicator
    IndicatorSeparator: () => null, // Optionally remove the separator
};

function checkStuckUploads(file) {
    const now = new Date();
    const createdAt = new Date(file.fileCreated);
    const diffInMs = now - createdAt;
    const diffInMinutes = diffInMs / 1000 / 60;
    return file.uploadStatus === "INPROGRESS" && diffInMinutes > 30;
}


const ViewLearningCase = () => {
    const transformRef = useRef(null);
    const viewerRef = useRef(null);

    const inputRef = useRef(null);


    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [failedData, setFailedData] = useState([]);


    const [baseUrl, setBaseUrl] = useState("https://qih3mm5tl8.execute-api.ap-south-1.amazonaws.com/prod/")
    const [partsize, setPartsize] = useState(100)
    const [numuploads, setNumuploads] = useState(3)
    const [ta, setTa] = useState(undefined)
    const [pgvalue, setPgvalue] = useState(undefined)
    const [perf, setPerf] = useState(undefined)

    const [diagnosisError, setdiagnosisError] = useState('');
    const [youtubeError, setyoutubeError] = useState('');
    const [descriptionError, setdescriptionError] = useState('');
    const [statusError, setstatusError] = useState('');
    const [explanationError, setexplanationError] = useState('');
    const [tagError, settagError] = useState('');
    const [answer1Error, setanswer1Error] = useState('');
    const [answer2Error, setanswer2Error] = useState('');
    const [formData, setFormData] = useState('');
    const [fileDimension, setFileDimension] = useState({})

    const [caseIdDynamic, setCaseId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({ diagnosis: '', clinicalhistory: '', youtube: '', tag: '', explanation: '', answer1: '', answer2: '', answer11: '' });
    const [permission, setPermission] = useState({});
    const [completedFiles, setCompletedFiles] = useState([]);

    const [success, setSuccess] = useState(false);

    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');

    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);

    const [imageErrorFiles, setImageErrorFiles] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [inputChange, setInputChange] = useState(true);
    const [questionData, setQuestionData] = useState(null);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [resourceBucket, setResourceImg] = useState(false);

    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imagesUrls, setImageUrls] = useState(null);
    const [imageFiles, setImageFiles] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [alertPopup, setAlertPopup] = useState(false)
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [successAPI, setSuccessAPI] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [uploadImg, setUploadImg] = useState(false);
    const [deleteimageType, setImageType] = useState(null);
    const [loading, setLoading] = useState(true);

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)

    const [uploadedFiles, setUploadedFiles] = useState([])

    const [cpcList, setCPCInfo] = useState([])
    const [moduleList, setModuleInfo] = useState([])

    // Deepzoom
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");

    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [dziImageList, setDziImageList] = useState([]);
    const [dziCurrentIndex, setDziCurrentIndex] = useState(0);
    const [isDziLoading, setIsDziLoading] = useState(false);
    const [isClinicalLoading, setIsClinicalLoading] = useState(false);



    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [clinicalPopupList, setClinicalPopupList] = useState([]);
    const [clinicalPopupIndex, setClinicalPopupIndex] = useState(0);
    const [answers, setAnswersData] = useState(null);
    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});




    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);

    // Share feature states
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareFile, setShareFile] = useState(null);
    const [shareExpiryAt, setShareExpiryAt] = useState(null);
    const [shareUrl, setShareUrl] = useState('');
    const [shareExpiresAt, setShareExpiresAt] = useState(null);
    const [shareGenerating, setShareGenerating] = useState(false);

    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity, setIsUploading, setIsUploadingFailed } = useContext(contentContext);
    let isFailed = false;
    useEffect(() => {

        failedData.length > 0 && failedData.forEach(file => {
            if (checkStuckUploads(file) && !isFailed) {
                // setIsUploadingFailed(true);
                isFailed = true;
                // toast.error(`File ${file.fileid} is stuck in upload. Please re-upload.`);
            }
        });
    }, [failedData])
   
    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);


    useEffect(() => {
        // debugger
        // console.log("imageFiles ,uploadedFiles, ", imageFiles, imageIndex, uploadedFiles)
        if (imageFiles && imageFiles?.length > 0 && uploadedFiles && uploadedFiles?.length > 0) {
            updateFilesAPI()
        }
    }, [uploadedFiles]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    const cf = window.site.common.imageCloudfront.replace(/^http:\/\//i, 'https://');
                    setImg(cf)
                    setimageCloudfront(cf)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            console.log('window.site.common', window.site.common)
            const cf = window.site.common.imageCloudfront.replace(/^http:\/\//i, 'https://');
            setImg(cf)
            setimageCloudfront(cf)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getLearningCaseInfo();


        }
        // getCpcInfo()
        getModuleInfo()
        GetAnswersInfo()
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);

    useEffect(() => {
        const uploads = JSON.parse(localStorage.getItem("uploads") || "[]");
        const now = Date.now();
        const THRESHOLD = 5 * 60 * 1000; // 5 minutes

        // Find all unfinished uploads older than threshold
        const unfinished = uploads.filter(
            (f) =>
                f.uploadStatus === "INPROGRESS" &&
                now - f.timestamp > THRESHOLD
        );

        if (unfinished.length > 0) {
            // alert(
            //     `These files failed to upload: ${unfinished
            //         .map((f) => f.fileName)
            //         .join(", ")}`
            // );
            setIsUploadingFailed(true)
            setTimeout(function () {
                setIsUploadingFailed(false);

            }, 2000)
            setIsUploading(false)

            // Mark them as FAILED in localStorage
            const updatedUploads = uploads.map((f) => {
                if (
                    f.uploadStatus === "INPROGRESS" &&
                    now - f.timestamp > THRESHOLD
                ) {
                    return { ...f, uploadStatus: "FAILED" };
                }
                return f;
            });

            localStorage.setItem("uploads", JSON.stringify(updatedUploads));
        }
    }, []);
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            if (typeof response?.result === 'object') {
                let ans = response?.result?.answerData || [];
                if (ans.length > 0) {
                    let tmpArr = [];
                    ans.forEach(a => {
                        let obj = {
                            value: `${a.answerid}`,
                            label: a.answer
                        }
                        tmpArr.push(obj)
                    })
                    setAnswersData(tmpArr);

                    setFilteredOptionsMap({
                        answer1: tmpArr,
                        answer11: tmpArr,
                        answer2: tmpArr
                    })


                }

            }
        } catch {
            console.log("error");
        }
    };


    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity

        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);


    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        setDziImageList([]);
        setDziCurrentIndex(0);
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };

    const buildTileSourceForFile = (file) => {
        let path = file.dziUrl || "";
        if (path.startsWith("/")) path = path.slice(1);
        const isDziURL = path.includes("output.dzi");
        if (isDziURL) {
            path = `${path}_files/`;
            return {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(imageCloudfront + path),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: file.width, Height: file.height },
                },
            };
        }
        const url = encodeURI(`${imageCloudfront}${(file.sourcepath || "").replace(/ /g, "%20")}?auto=compress,format`);
        return { type: "image", url, buildPyramid: false };
    };

    const navigateDziImage = (newIndex) => {
        if (!dziImageList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, dziImageList.length - 1));
        const file = dziImageList[clamped];
        if (!file) return;
        const tileSource = buildTileSourceForFile(file);
        if (viewer) {
            setIsDziLoading(true);
            viewer.open(tileSource);
            viewer.viewport.setRotation(0);
            viewer.addOnceHandler("open", () => setIsDziLoading(false));
        }
        setDziCurrentIndex(clamped);
        setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename);
        setDZIPopupImage(imageCloudfront + file.sourcepath);
        setRotation(0);
    };

    const handleClinicalPopupOpen = (list, index) => {
        setShowImagePopup(true);
        setIsClinicalLoading(true);
        setPopupImage(list[index]);
        setClinicalPopupList(list);
        setClinicalPopupIndex(index);
    };

    const navigateClinicalImage = (newIndex) => {
        if (!clinicalPopupList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, clinicalPopupList.length - 1));
        setIsClinicalLoading(true);
        setPopupImage(clinicalPopupList[clamped]);
        setClinicalPopupIndex(clamped);
    };

    useEffect(() => {
        if (!isPopupOpen || dziImageList.length <= 1) return;
        const handleArrowNav = (e) => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                navigateDziImage(dziCurrentIndex - 1);
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                navigateDziImage(dziCurrentIndex + 1);
            }
        };
        window.addEventListener("keydown", handleArrowNav);
        return () => window.removeEventListener("keydown", handleArrowNav);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPopupOpen, dziImageList, dziCurrentIndex, viewer]);

    useEffect(() => {
        if (!showImagePopup || clinicalPopupList.length <= 1) return;
        const handleClinicalArrow = (e) => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                navigateClinicalImage(clinicalPopupIndex - 1);
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                navigateClinicalImage(clinicalPopupIndex + 1);
            }
        };
        window.addEventListener("keydown", handleClinicalArrow);
        return () => window.removeEventListener("keydown", handleClinicalArrow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showImagePopup, clinicalPopupList, clinicalPopupIndex]);

    const getModuleInfo = async () => {
        const response = await tmdbApi.getmoduleInfo("ACTIVE");

        if (response?.result?.data?.length > 0) {
            setModuleInfo(response?.result?.data)
        }
    }


    const getLearningCaseInfo = (e) => {
        try {
            setLoading(true)
            GetTimeActivity()
            const userId = localStorage.getItem("userId")
            const token = localStorage.getItem("token")
            axios({
                method: 'POST',
                url: lambda + '/learningCaseInfo?appname=' + appname + '&userid=' + userId + '&caseid=' + id + '&token=' + token,
            })
                .then(function (response) {
                    //  console.log("response", response?.data?.result?.[0]);
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    }
                    else {
                        if (response?.data?.result?.questionData?.length > 0) {
                            setImageUrls([])
                            setEditUser(response?.data?.result?.questionData?.[0]);
                            // console.log(response?.data?.result, "ccssd s");
                            if (response?.data?.result?.questionData?.[0]?.files && response?.data?.result?.questionData?.[0]?.files?.length > 0) {
                                let completedFiles = response?.data?.result?.questionData?.[0]?.files.filter(file => file.dzistatus === "COMPLETED") || [];
                                setCompletedFiles(completedFiles)
                            }

                            const filesData = response?.data?.result?.questionData?.[0]?.files || [];
                            setFailedData(filesData)

                            // setTags(response?.data?.result?.questionData?.[0]?.tags || [])
                            if (response?.data?.result?.questionData?.[0] && response?.data?.result?.questionData?.[0]?.permissions) {
                                setPermission(response?.data?.result?.questionData?.[0]?.permissions)
                            }
                        } else {
                            setInvalidContent(true)
                        }
                    }
                    setLoading(false);
                });

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }



    const onDescriptionChange = (e) => {
        setEditUser((prevData) => ({
            ...prevData,
            clinicalhistory: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const onExplanationChange = (e) => {
        setEditUser((prevData) => ({
            ...prevData,
            explanation: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };


    const noImageComponent = () => {
        return (
            <div className="uploaded_images-grid mt-0 view-case-no-img-block">
                <div className="upload-box">
                    <div className="file_upload add-box">
                        <label htmlFor="file-upload" className="Add-btn d-flex align-items-center justify-content-center">
                            No image
                        </label>
                    </div>
                </div>
            </div>
        );
    };



    const imageExtensions = ['.tif', '.tiff', '.jpeg', '.jpg', '.png'];
    const MAX_PIXELS = 10000000000;
    const handleFileChange = async (event) => {
        try {
            const input = event.target;
            const selectedFiles = Array.from(input.files);
            selectedFiles.filter(file => {
                const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
                if (!imageExtensions.includes(ext)) {
                    // Optionally show a message that non-image files are rejected
                    setFileSizeError(true);
                    setFileSizeErrorMsg(`File type "${ext}" is not supported.`);
                    return false;
                }
            });
            setInputChange(false);

            let filesLength = 0;
            if (editUser && editUser?.files?.length > 0) {
                filesLength += editUser.files.length;
            }
            if (imageFiles && imageFiles?.length > 0) {
                filesLength += imageFiles.length;
            }
            if (selectedFiles && selectedFiles.length > 0) {
                filesLength += selectedFiles.length;
            }

            if (filesLength > 10) {
                setAlertPopup(true);
                return;
            }

            setImageDisplay(true);

            // const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB

            for (let index = 0; index < selectedFiles.length; index++) {
                const file = selectedFiles[index];
                let dimensions = { width: null, height: null, resolution: null };
                try {
                    dimensions = await getGeoTiffDimensions(file)
                    // debugger
                    let msg = "";

                    let tnpDim = { ...fileDimension }
                    tnpDim[file.name] = dimensions

                    setFileDimension(tnpDim)
                    if ((dimensions.width * dimensions.height) > MAX_PIXELS) {
                        msg += `Resolution (width Ã— height) of "${file.name}" exceeds the maximum allowed 10,000,000,000 pixels. `;
                    }
                    if (msg !== "") {
                        setFileSizeError(true);
                        setFileSizeErrorMsg(msg);
                        continue; // Skip this file and continue with next
                    }
                    input.value = "";
                } catch (e) {
                    console.log(e.message);
                }
            }

            for (let index = 0; index < selectedFiles.length; index++) {
                const file = selectedFiles[index];


                let adjustedIndex = index;
                if (imageIndex > 0) {
                    adjustedIndex = index + imageIndex;
                }

                const urlobj = URL.createObjectURL(file);

                setImageFiles((prevData) => [...prevData, file]);

                setImageUrls((prevData) => ({
                    ...prevData,
                    ["blob" + adjustedIndex]: {
                        url: urlobj,
                        name: file.name,
                    },
                }));

                setImageIndex(adjustedIndex + 1);
            }
        } catch (err) {
            console.log(err, "err")
        }
    };


    const handleClinicalImageDelete = (e, key) => {
        // remove from urls
        setClinicalImageUrls((prev) => {
            const updated = { ...prev };
            if (updated[key]) {
                delete updated[key];
            }
            console.log("After delete clinicalImageUrls:", updated);
            return updated;
        });

        // remove from files by id
        setclinicalImageFiles((prev) => {
            const updated = prev.filter((f) => f.id !== key);
            console.log("After delete clinicalImageFiles:", updated);
            return updated;
        });
    };




    const handleimageFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setInputChange(false);

        let clinicalCount = 0;
        if (clinicalimageFiles?.length > 0) clinicalCount += clinicalimageFiles.length;
        if (imageFiles?.length > 0) clinicalCount += imageFiles.length;
        if (selectedFiles?.length > 0) clinicalCount += selectedFiles.length;

        if (clinicalCount > 10) {
            setAlertPopup(true);
            input.value = null;
            return;
        }

        const historyFilesLength = editUser?.historyfiles?.length || 0;
        const totalCount = historyFilesLength + clinicalCount;

        if (totalCount > 10) {
            setAlertPopup(true);
            input.value = null;
            return;
        }

        selectedFiles.forEach((file) => {
            let fileSize = 1048612 * 20; // 20MB
            if (file?.size < fileSize) {
                let urlobj = URL.createObjectURL(file);
                let img = new Image();
                img.onload = function () {

                    const uniqueKey = `${file.name}-${Date.now()}-${Math.random()}`;


                    setclinicalImageFiles((prevData) => {
                        const updated = [...prevData, { id: uniqueKey, file }];
                        console.log("Updated clinicalimageFiles:", updated);
                        return updated;
                    });


                    setClinicalImageUrls((prevData) => {
                        const updated = {
                            ...prevData,
                            [uniqueKey]: {
                                url: urlobj,
                                name: file?.name,
                                id: uniqueKey,
                            },
                        };
                        console.log("Updated clinicalImageUrls:", updated);
                        return updated;
                    });
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true);
                setFileSizeErrorMsg("File size greater than 20MB");
            }
        });
    };


    const handleFileUpload = async (clinicalimageFiles, caseid) => {
        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            let filesArray = [];

            const uploadPromises = clinicalimageFiles.map(async (fileObj) => {
                const file = fileObj.file;
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                if (file.type.startsWith("image/")) {
                    let filenameReplace = file.name.replace(/ /g, "_");
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;
                    uploadFilePath = `${appname}/cases/clinicalhistory/${caseid}/${fileNameUnique}`;
                    bucket = window.site?.common?.resourceBucket;


                    const data = {
                        source_bucket: bucket,
                        sourcepath: uploadFilePath,
                        filename: fileNameUnique,
                    };

                    const newFile = {
                        filename: filenameReplace.split(".")[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    };

                    filesArray.push(newFile);
                    setFiles((files) => [...files, newFile]);

                    try {
                        // Get Upload URL
                        const uploadUrlResponse = await axios.post(
                            `${lambda}/uploadFiles?appname=${appname}&caseid=${caseid}`,
                            data,
                            { headers: { "Content-Type": "application/json" } }
                        );

                        if (uploadUrlResponse.data?.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            // Upload file to S3
                            const uploadResponse = await axios.put(uploadUrl, file, {
                                headers: {
                                    "Content-Type": file.type,
                                    "Cache-Control": "no-cache",
                                },
                            });

                            if (uploadResponse.status === 200) {
                                console.log(`Uploaded: ${file.name}`);
                                return true;
                            } else {
                                throw new Error("Failed to upload file to S3");
                            }
                        } else {
                            throw new Error("Failed to get upload URL");
                        }
                    } catch (error) {
                        console.error("File upload error:", error);
                        return false;
                    }
                }
            });

            try {
                await Promise.all(uploadPromises);
                console.log("All files uploaded:", filesArray);
            } catch (error) {
                console.error("Error during file upload:", error);
            }
        }
    };


    const createProgressToast = (fileName) => {
        let progressToastId = toast(`Uploading ${fileName}...`, {
            progress: 0,
            closeOnClick: false,
            autoClose: false,

        });

        return progressToastId;
    };

    // Function to update progress toast
    const updateProgressToast = (toastId, progress) => {
        toast.update(toastId, {
            progress: progress / 100,
        });
    };

    // Function to close and show success or error message
    const finalizeToast = (toastId, fileName, success = true) => {
        toast.update(toastId, {
            render: success ? `${fileName} uploaded successfully!` : `${fileName} failed to upload.`,
            type: success ? 'success' : 'error',  // Using 'success' and 'error' as strings
            autoClose: 2000,
            closeOnClick: true,
        });

    };

    const handleUploadfunction = async (files, caseid) => {

        if (files && files.length > 0) {
            const uploadPromises = Array.from(files).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('clientid');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;
                // console.log("filesssss ", file)
                // Check the file type
                if (file) {
                    // File is a video
                    // uploadFilePath = `${clientid}/files/${uniqueId}_video_${timestamp}.${fileExtension}`;
                    bucket = window.site && window.site.common && window.site.common.resourceBucket; // Use source bucket for videos
                    // videoUploadFunction(uploadFilePath,bucket)
                    const timestamp = Date.now();
                    const fileExtension = file?.name?.split('.').pop();
                    const clientid = localStorage.getItem('clientid');

                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const uploadFilePath = `${appname}/cases/histology/${caseid}/${uniqueId}/`;
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;

                    let uploads = JSON.parse(localStorage.getItem("uploads") || "[]");
                    const uploadEntry = {
                        fileName: fileNameUnique,
                        uploadStatus: "INPROGRESS",
                        timestamp: timestamp
                    };
                    uploads.push(uploadEntry);
                    localStorage.setItem("uploads", JSON.stringify(uploads));

                    const uploaderOptions = {
                        file: file,
                        baseURL: baseUrl,
                        chunkSize: partsize,
                        threadsQuantity: numuploads,
                        useTransferAcceleration: ta,
                        bucket: uploadFilePath,
                        fileNameUnique: fileNameUnique,
                        sourceBucket: bucket,
                        setIsUploading: setIsUploading,
                        setIsUploadingFailed: setIsUploadingFailed
                    };

                    let percentage = undefined;
                    setPgvalue(0);
                    setPerf("-");
                    const uploader = new Uploader(uploaderOptions);
                    const tBegin = performance.now();
                    //console.log('tBegin', tBegin);
                    // Get image dimensions before upload



                    const newFile = {
                        fileCreated: new Date(),
                        filename: fileNameUnique,
                        sourcepath: uploadFilePath + fileNameUnique,
                        fileid: uniqueId,
                        originalFilename: file.name,
                        uploadStatus: "INPROGRESS",
                        fileSize: file.size, // in bytes
                        width: fileDimension?.[file.name]?.width || 0,
                        height: fileDimension?.[file.name]?.height || 0,
                        resolution: fileDimension?.[file.name]?.resolution || 0,

                    };
                    console.log('newwww ', newFile)
                    setUploadedFiles((uploadedFiles) => [...uploadedFiles, newFile]);

                    //const progressToastId = createProgressToast(file.name);

                    // uploader
                    //     .onProgress(({ percentage: newPercentage }) => {
                    //         // Avoid logging the same percentage twice
                    //         if (newPercentage !== percentage) {
                    //             percentage = newPercentage;
                    //             setPgvalue(percentage);
                    //             //updateProgressToast(progressToastId, percentage);

                    //             if (percentage === 100) {
                    //                 setPerf((performance.now() - tBegin) / 1000);
                    //             }
                    //         }
                    //     })
                    //     .onError((error) => {
                    //         console.error(error);
                    //        // finalizeToast(progressToastId, file.name, false);
                    //     });

                    uploader.start();


                } else {
                    // File type is neither image nor video
                    // toast.error('Unsupported file type');
                    return;
                }
                //  console.log('Upload File Path:', uploadFilePath);

            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);



            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }

    };
    const handlePopupImage = (imageUrl) => {
        setShowImagePopup(true);
        setPopupImage(imageUrl);
        setClinicalPopupList([]);
        setClinicalPopupIndex(0);
    };

    const updateFilesAPI = () => {
        // console.log('uploadedFi2222 ', uploadedFiles)
        let payload = {
            files: uploadedFiles
        }

        payload["caseid"] = caseIdDynamic

        axios({
            method: 'POST',
            url: lambda + "/updateLearningCase?appname=" + appname + '&caseid=' + caseIdDynamic,
            data: payload,
        })
            .then(function (response) {
                setImageFiles([]);
                setUploadedFiles([]);


            });
    }



    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }



        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        } else if (name == "assignedCpc") {
            let assignedCpcValue = value.split("|")
            console.log("valddd ", value, assignedCpcValue[0], assignedCpcValue[1])
            setEditUser(prev => ({ ...prev, "assignedCpc": assignedCpcValue[0], "assignedCpcTitle": assignedCpcValue[1] }));
        } else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        setSuccess(false);
        navigate("/cases", { state: { restoreListPage: true } })
    };

    function onUpdateConfirm() {
        setUpdateSuccess(false);
        getLearningCaseInfo()

        if (imageFiles && imageFiles.length > 0) {
            setImageUrls(null);
            setImageFiles([])
            setImageIndex(0)
        }

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            setClinicalImageUrls(null);
            setclinicalImageFiles([])
            setClinicalImageIndex(0)
        }

    };

    const handleAddUser = (e, status) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            const caseid = uuid();
            // if (imageFiles && imageFiles.length > 0) {
            //   handleFileUpload(caseid, "create")
            // } else {
            createuser(imageFiles, caseid, status);
            //  }

        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (editUser?.diagnosis === undefined || editUser?.diagnosis?.trim() === "") {
            setdiagnosisError("Please enter Diagnosis");
            // setTimeout(function () { setdiagnosisError("") }, 3000);
            formIsValid = false;
        } else {
            setdiagnosisError("")
        }

        // if (id && tags && tags?.length == 0) {
        //     settagError("Please enter Tags");
        //     // setTimeout(() => settagError(""), 3000);
        //     formIsValid = false;
        // } else {
        //     settagError("")
        // }

        if (id && (editUser?.clinicalhistory === undefined || editUser?.clinicalhistory?.trim() === "")) {
            setdescriptionError("Please enter Clinical history");
            // setTimeout(function () { setdescriptionError("") }, 3000);
            formIsValid = false;
        } else {
            setdescriptionError("")
        }

        if (id && !editUser?.explanation?.trim()) {
            setexplanationError("Please enter Explanation");
            //  setTimeout(() => setexplanationError(""), 3000);
            formIsValid = false;
        } else {
            setexplanationError("")
        }

        if (id && !editUser?.answer1?.value) {
            setanswer1Error("Please select answer (1 Point)");
            //setTimeout(() => setanswer1Error(""), 3000);
            formIsValid = false;
        } else {
            setanswer1Error("")
        }



        return formIsValid;
    }


    const handleSubmit = (status) => {
        GetTimeActivity()
        setIsLoading(true)



        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "diagnosis": editUser?.diagnosis,
            "clinicalhistory": editUser?.clinicalhistory,
            "youtube": editUser?.youtube,
            // "tags": tags,
            "explanation": editUser?.explanation,
            "answer1": editUser?.answer1,
            "answer11": editUser?.answer11,
            "answer2": editUser?.answer2
        }

        if (editUser?.youtube) {
            payload["thumbnail"] = `https://img.youtube.com/vi/${getYouTubeVideoId(editUser?.youtube)}/0.jpg`
        }
        payload["caseid"] = id
        if (status) {
            payload["status"] = status
        }


        // if (editUser?.assignedCpc) {
        //     payload["assignedCpc"] = editUser?.assignedCpc
        // }

        if (editUser?.assignedCpc) {
            //let assignedCpcValue = editUser?.assignedCpc.split("|")
            payload["assignedCpc"] = editUser?.assignedCpc
        }
        if (editUser?.assignedCpcTitle) {
            payload["assignedCpcTitle"] = editUser?.assignedCpcTitle
        }

        if (editUser?.assignedModule) {
            payload["assignedModule"] = editUser?.assignedModule
        }

        if (imageFiles && imageFiles.length > 0) {
            // payload["imageStatus"] = 'INPROGRESS'
        }

        axios({
            method: 'POST',
            url: lambda + "/updateLearningCase?appname=" + appname + '&caseid=' + id,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (imageFiles && imageFiles?.length > 0) {
                        handleUploadfunction(imageFiles, id)
                    }
                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, id)
                    }
                    setCaseId(id)
                    if (response?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        //setSuccessAPI(true)
                        setSuccessMsg("Updated Successfully")
                        //setToastMessage("Updated Successfully")

                        //if (id && imageFiles?.length == 0) {
                        // getLearningCaseInfo();


                        //}
                        setTimeout(() => {
                            // navigate("/cases"); // Trigger API call AFTER toast is displayed
                        }, 2000);
                    }
                }

            });
    }


    const handleUpdate = (e, status) => {
        GetTimeActivity()

        if (status == "ACTIVE") {
            const isValid = formvalidation();
            // if (imageFiles && imageFiles.length > 0) {
            //   handleFileUpload(id, "update")
            //  } else {
            if (isValid) {
                handleSubmit(status);
            }

            // }
        } else {
            handleSubmit(status);
        }
    }

    const createuser = async (imageFiles, caseid, status) => {
        setIsLoading(true)


        // GetTimeActivity()   
        let payload = {}
        payload = {
            "diagnosis": editUser?.diagnosis,
            "clinicalhistory": editUser?.clinicalhistory,
            "youtube": editUser?.youtube,
            // "status": editUser?.status,
            "explanation": editUser?.explanation,
            "tags": tags,
            // "thumbnail": `https://img.youtube.com/vi/${getYouTubeVideoId(editUser?.youtube)}/0.jpg`,

            "answer1": editUser?.answer1,
            "answer11": editUser?.answer11,
            "answer2": editUser?.answer2
        }

        payload["caseid"] = caseid

        payload["status"] = status

        if (editUser?.youtube) {
            payload["thumbnail"] = `https://img.youtube.com/vi/${getYouTubeVideoId(editUser?.youtube)}/0.jpg`
        }

        if (editUser?.assignedCpc) {
            //let assignedCpcValue = editUser?.assignedCpc.split("|")
            payload["assignedCpc"] = editUser?.assignedCpc
        }
        if (editUser?.assignedCpcTitle) {
            payload["assignedCpcTitle"] = editUser?.assignedCpcTitle
        }
        if (editUser?.assignedModule) {
            payload["assignedModule"] = editUser?.assignedModule
        }

        if (imageFiles && imageFiles.length > 0) {
            // payload["imageStatus"] = 'INPROGRESS'
        }

        const userId = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + "/addLearningCase?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.resultimageFiles", response, imageFiles, caseid)
                    if (imageFiles && imageFiles?.length > 0) {
                        handleUploadfunction(imageFiles, caseid)
                    }

                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, caseid)
                    }

                    setCaseId(caseid)

                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);

                        setSuccessMsg("Created Successfully")

                        // setToastMessage("Created Successfully")
                        //setTimeout(() => {
                        // navigate("/cases"); // Trigger API call AFTER toast is displayed
                        //}, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        navigate("/cases", { state: { restoreListPage: true } })
    }

    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/cases", { state: { restoreListPage: true } })
    }



    const handleSelectAll = (e, updatedType, menuItemIndex, submenuIndex) => {
        const checked = e.target.checked;
        // console.log('menuItemIndex',menuItemIndex)
        // console.log('submenuIndex',submenuIndex)
        setPermission(prevState => {
            if (submenuIndex === undefined) {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedDashboard = Object.keys(menuItem.dashboard).reduce((obj, key) => {
                            obj[key] = { ...menuItem.dashboard[key], [updatedType]: checked };
                            return obj;
                        }, {});
                        return { ...menuItem, [updatedType]: checked, dashboard: updatedDashboard };
                    }
                    return menuItem;
                });
            } else if (submenuIndex === "submenus") {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        // console.log('menuItem.submenus',menuItem.submenus)
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {

                            const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                return obj
                            }, {});

                            return { ...submenu, [updatedType]: checked, dashboard: kk };

                        });
                        return { ...menuItem, [updatedType]: checked, submenus: updatedSubmenus };

                    }
                    return menuItem;
                });
            }

            else {

                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {
                            if (j === submenuIndex) {

                                const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                    obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                    return obj
                                }, {});

                                return { ...submenu, [updatedType]: checked, dashboard: kk };
                            }
                            return submenu;
                        });
                        return { ...menuItem, submenus: updatedSubmenus };
                    }
                    return menuItem;
                });
            }
        });
        // console.log('permissionss',permission)
    };

    const handleChangeEachItem = (e, index, subIndex, type, typeOfItem, updatedType, subSubIndex) => {
        const updatedPermission = [...permission];
        const isChecked = e.target.checked;
        // console.log('typeeee',type)
        // console.log('index',index)
        // console.log('subIndex',subIndex)
        // console.log('updatedPermission',updatedPermission)
        // console.log('typeOfItem',typeOfItem)
        if (typeOfItem === 'dashboard') {
            updatedPermission[index].dashboard[type][updatedType] = isChecked;
        } else if (typeOfItem === 'submenus') {
            updatedPermission[index].submenus[subSubIndex].dashboard[type][updatedType] = isChecked;
            if (isChecked && updatedPermission[index].dashboard) {
                Object.keys(updatedPermission[index].dashboard).forEach(key => {
                    updatedPermission[index].dashboard[key][updatedType] = true;
                });
            }
        }

        setPermission(updatedPermission);
    };


    const handlePopupload = (e) => {
        setPopupLoading(true)
    }

    const handleShareClick = (file) => {
        setShareFile(file);
        setShareExpiryAt(dayjs().add(1, 'hour'));
        setShareUrl('');
        setShareExpiresAt(null);
        setShowShareModal(true);
    };

    const isShareExpiryValid = shareExpiryAt && shareExpiryAt.isValid() && shareExpiryAt.diff(dayjs(), 'minute') >= 1;

    const getShareExpiryCountdown = () => {
        if (!isShareExpiryValid) return '';
        const mins = shareExpiryAt.diff(dayjs(), 'minute');
        const days = Math.floor(mins / 1440);
        const hrs = Math.floor((mins % 1440) / 60);
        const rem = mins % 60;
        if (days > 0) return `${days} day${days !== 1 ? 's' : ''}${hrs > 0 ? ` ${hrs} hr` : ''} from now`;
        if (hrs > 0) return `${hrs} hr${rem > 0 ? ` ${rem} min` : ''} from now`;
        return `${rem} min from now`;
    };

    const handleGenerateShareUrl = async () => {
        if (!shareExpiryAt || !shareExpiryAt.isValid() || shareExpiryAt.diff(dayjs(), 'minute') < 1) {
            toast.error("Please select a valid future date and time.", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
            return;
        }
        // Backend accepts whole hours — round up so the link never expires before the selected time.
        const hours = Math.max(1, Math.ceil(shareExpiryAt.diff(dayjs(), 'minute') / 60));
        setShareGenerating(true);
        try {
            const response = await tmdbApi.generateShareUrl(id, {
                fileid: shareFile?.fileid,
                sourcepath: shareFile?.sourcepath,
                dziUrl: shareFile?.dziUrl,
                width: shareFile?.width,
                height: shareFile?.height,
                hours,
            });
            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
                setShowShareModal(false);
                return;
            }
            const shareId = response?.result;
            if (!shareId) {
                toast.error("Failed to generate share link. Please try again.", {
                    position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                    closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
                });
                return;
            }
            const generatedUrl = `${window.location.origin}/shared-view/${shareId}`;
            setShareUrl(generatedUrl);
            setShareExpiresAt(response?.data?.result?.expiresAt || null);
            toast.success("Share link generated successfully!", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        } catch (err) {
            toast.error("Failed to generate share link. Please try again.", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        } finally {
            setShareGenerating(false);
        }
    };

    const handleCopyShareUrl = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            toast.success("Link copied to clipboard!", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        }).catch(() => {
            toast.error("Failed to copy link.", {
                position: "bottom-center", autoClose: 2000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
            });
        });
    };

    const handleWhatsAppShare = () => {
        const text = encodeURIComponent(`View this histology image: ${shareUrl}`);
        window.open(`https://wa.me/?text=${text}`, '_blank');
    };

    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
            }

            if (deleteimageType == "file") {

                await tmdbApi.deleteHistoricFiles(id, { ...params, "filename": deleteImageId?.filename });
            } else {

                await tmdbApi.deleteOmeFiles(id, { ...params, "fileid": deleteImageId?.fileid });
            }


            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        // let deleteImageIndex = deleteImageId["index"]
        // if (deleteImageIndex > -1) { // only splice array when item is found
        //     editUser["historyfiles"].splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        // }
        setDeleteImageId(null)
        // let imgIndex = clinicalimageIndex
        // setClinicalImageIndex(imgIndex - 1)
        getLearningCaseInfo()
    }

    // console.log("imageFiles", imagesUrls, imageFiles);

    const handleSelectChange = (selectedOption, aIndex) => {
        console.log("selectedOption:", selectedOption, "aIndex:", aIndex);

        const isFullPoint = aIndex === "answer1" || aIndex === "answer11";
        const updatedPoint = isFullPoint ? 1 : 0.5;

        setEditUser(prevData => ({
            ...prevData,
            [aIndex]: {
                ...selectedOption,
                points: updatedPoint
            }
        }));
    };


    const handleInputChange = (inputValue, aIndex) => {

        if (inputValue !== "") {
            const results = answers?.filter(option =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: answers
            }));
        }
    };

    // const [selectedFormat, setSelectedFormat] = useState(".tif,.tiff");
    // const handleFormatChange = (e) => {
    //     setSelectedFormat(e.target.value);
    // };

    const getExtension = (filename) => {
        if (!filename) return null;
        let extType = filename.split('.').pop().toLowerCase();
        let valReturn = ".jpeg,.jpg,.png";
        if (extType === 'tiff' || extType === 'tif') {
            valReturn = ".tif,.tiff";
        }
        return valReturn
    };



    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper" className="editcase-mob-res editcase-mob-1">
                <Header />
                <SideMenu />
                {/* <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert> */}
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "CASE DETAILS" : "VIEW CASE"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Learning Hub</span> / <b id="breadcrumb-action">{id === undefined ? "ADD CASE" : "VIEW CASE"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {!loading ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">
                                                    <div className="d-flex flex-wrap col-lg-12 col-md-12 justify-content-between align-items-start">
                                                        <div className="col-lg-6">
                                                            <b className="mb-2 answer-text">Case Info</b>
                                                            <div className="col-lg-12 col-md-12 mt-2">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Case Number</label>
                                                                    <input id="diagnosisid" name="diagnosisid" placeholder="Enter Case number" type="text" className="form-control" aria-invalid="false" disabled={true} value={editUser?.diagnosisid} />

                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 col-md-12 mt-2">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">DIAGNOSIS</label>
                                                                    <input id="diagnosis" disabled name="diagnosis" placeholder="Enter Diagnosis" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.diagnosis} />
                                                                    <span id="diagnosis-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{diagnosisError}</span>
                                                                </div>
                                                            </div>



                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field clinical-history">
                                                                    <label className="form-label form-label">Clinical History
                                                                        {/* {id && <span className="required">*</span>} */}
                                                                    </label>

                                                                    <Editor name="clinicalhistory" value={editUser?.clinicalhistory || "N/A"} onChange={(e) => onDescriptionChange(e)} disabled={true} />

                                                                    <span id="status-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{descriptionError}</span>



                                                                </div>
                                                            </div>

                                                            <div className="row">




                                                            </div>
                                                            <div className="col-lg-12 mt-4">

                                                                <div className="col-md-12 upload-imgs">

                                                                    {/* {editUser?.historyfiles?.length > 0 && */}
                                                                    <div className="d-flex col-lg-12 align-items-start justify-content-between upload-img-section">
                                                                        <label className="form_label col-4">CLINICAL HISTORY PHOTOS</label>

                                                                    </div>
                                                                    {/* } */}

                                                                    <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">



                                                                        {/* Uploaded clinical images */}
                                                                        {/* THUMBNAIL GRID */}
                                                                        <div className="deep-zoom-styles mb-3 mt-1" /* grid container */>
                                                                            {/* â”€â”€ Clinical images from local upload â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}


                                                                            {clinicalimagesUrls &&
                                                                                Object.keys(clinicalimagesUrls).map((item, key) => (
                                                                                    <div className="thumb-box" key={key}>
                                                                                        <div
                                                                                            className="thumb-img cursor-pointer"
                                                                                            onClick={() => {
                                                                                                const blobUrls = Object.keys(clinicalimagesUrls).map(k => clinicalimagesUrls[k].url);
                                                                                                const serverUrls = (editUser?.historyfiles || []).map(f => `${imageCloudfront}${f?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format`);
                                                                                                handleClinicalPopupOpen([...blobUrls, ...serverUrls], key);
                                                                                            }}
                                                                                        >
                                                                                            {/* <img
                                                                                                src={clinicalimagesUrls[item].url}
                                                                                                alt="uploaded"
                                                                                            /> */}


                                                                                        </div>
                                                                                        {/* <p className="thumb-name text-truncate small mb-0">
                                                                                            {clinicalimagesUrls[item].name}
                                                                                        </p> */}
                                                                                    </div>
                                                                                ))}




                                                                            {/* â”€â”€ Clinical images from editUser.historyfiles â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
                                                                            {editUser?.historyfiles?.length > 0 &&
                                                                                editUser.historyfiles.map((item, key) => {
                                                                                    const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')
                                                                                        }?auto=compress,format`;
                                                                                    return (
                                                                                        <div className="thumb-box" key={key}>
                                                                                            <div
                                                                                                className="thumb-img cursor-pointer"
                                                                                                onClick={() => {
                                                                                                    const blobUrls = clinicalimagesUrls ? Object.keys(clinicalimagesUrls).map(k => clinicalimagesUrls[k].url) : [];
                                                                                                    const serverUrls = (editUser?.historyfiles || []).map(f => `${imageCloudfront}${f?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format`);
                                                                                                    handleClinicalPopupOpen([...blobUrls, ...serverUrls], blobUrls.length + key);
                                                                                                }}

                                                                                            >
                                                                                                <img src={`${imagePath}&width=150`} alt="history" />



                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}

                                                                            {(editUser?.historyfiles === undefined || editUser?.historyfiles?.length <= 0) && noImageComponent()}
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                {/* â”€â”€ 2. HISTOLOGY PHOTOS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
                                                                <div className="row col-lg-12 mt-4 upload-imgs">

                                                                    <div className="col-lg-12 align-items-start justify-content-between upload-img-section pe-0 me-0">
                                                                        <label className="form_label col-12">HISTOLOGY PHOTOS</label>



                                                                    </div>


                                                                    <div className="mt-2 mb-0 pe-0">
                                                                        {/* {editUser?.files?.length > 0 ?
                                                                            editUser.files.filter(file => getExtension(file?.originalFilename) === ".jpeg,.jpg,.png").map.length > 0 && */}
                                                                        <div className="d-flex justify-content-between">
                                                                            <p className="case-type-text">PNG, JPEG, JPG Files</p>
                                                                            {/* <p className="mt-0 mb-0 text-muted file-format">Note: Max File size: 20 MB, Max files: 10 | Formats: PNG, JPEG, JPG</p> */}
                                                                        </div>

                                                                        {/* //     :
                                                                        //     <>  
                                                                        //     noImageComponent()</>
                                                                        // } */}

                                                                        <div className="d-flex justify-content-start col-lg-12 histology-photo-section gap-2 ">

                                                                            <div className="mb-1 mt-2 input-field deep-zoom-styles">


                                                                                {imagesUrls &&
                                                                                    Object.keys(imagesUrls).length > 0 &&
                                                                                    Object.keys(imagesUrls).filter(file => getExtension(imagesUrls[file].name) === ".jpeg,.jpg,.png").map((item, key) => (

                                                                                        <div className="thumb-box" key={key}>
                                                                                            <div
                                                                                                className="thumb-img cursor-pointer"
                                                                                            >
                                                                                                {/* <img
                                                                                                    src={item?.thumbnailUrl ? `${imageCloudfront}${item?.thumbnailUrl?.replace(/ /g, '%20')}?auto=compress,format` : deepZoom}
                                                                                                    alt="uploaded"
                                                                                                /> */}


                                                                                            </div>

                                                                                        </div>
                                                                                    ))}




                                                                                {editUser?.files?.length > 0 ?
                                                                                    editUser.files.filter(file => getExtension(file?.originalFilename) === ".jpeg,.jpg,.png").map((file, key) => {
                                                                                        const imagePath = `${imageCloudfront}${file?.sourcepath?.replace(/ /g, '%20')
                                                                                            }?auto=compress,format`;
                                                                                        return (
                                                                                            <div className="thumb-box" key={key}>
                                                                                                <div
                                                                                                    className="thumb-img cursor-pointer"
                                                                                                    onClick={(e) => {

                                                                                                        if (
                                                                                                            file.allow &&
                                                                                                            (!file.dzistatus || String(file.dzistatus).toUpperCase() !== "COMPLETED")
                                                                                                        ) {


                                                                                                            e.preventDefault();
                                                                                                            console.log("⏳ DZI still processing — preview disabled.");
                                                                                                            return; // stop further actions
                                                                                                        }
                                                                                                        // handlePopupImage(imagePath)
                                                                                                        setPopupOpen(true);
                                                                                                        setImageDimensions({ width: file.width, height: file.height });

                                                                                                        let path = file.dziUrl || "";
                                                                                                        if (path.startsWith("/")) path = path.slice(1);
                                                                                                        let isDziURL = path.includes("output.dzi");
                                                                                                        if (isDziURL) {
                                                                                                            path = `${path}_files/`;
                                                                                                            setDziUrl(imageCloudfront + path);
                                                                                                        } else {
                                                                                                            setDziUrl(imagePath);
                                                                                                        }

                                                                                                        setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                        setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                        handlePopupload(e);

                                                                                                        const viewableFiles = (editUser?.files || []).filter(f =>
                                                                                                            f.uploadStatus === "COMPLETED" &&
                                                                                                            getExtension(f?.originalFilename) === ".jpeg,.jpg,.png" &&
                                                                                                            (!f.allow || String(f.dzistatus).toUpperCase() === "COMPLETED")
                                                                                                        );
                                                                                                        const clickedIdx = viewableFiles.findIndex(f =>
                                                                                                            (f.fileid && f.fileid === file.fileid) || f.sourcepath === file.sourcepath
                                                                                                        );
                                                                                                        setDziImageList(viewableFiles);
                                                                                                        setDziCurrentIndex(clickedIdx >= 0 ? clickedIdx : 0);

                                                                                                    }}
                                                                                                >



                                                                                                    <img src={


                                                                                                        file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                            file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                        )}

                                                                                                        onError={(e) => {
                                                                                                            e.currentTarget.onerror = null; // Prevent looping
                                                                                                            e.currentTarget.src = deepZoom; // your default image path
                                                                                                        }}
                                                                                                        alt={file?.originalFilename} />
                                                                                                    {file?.uploadStatus !== "COMPLETED" && !file?.dzistatus && (
                                                                                                        <span className="material-symbols-outlined img_view loadingIcon"><img src={loadingIcon} alt="" /></span>
                                                                                                    )}
                                                                                                    {((file?.dzistatus === "INPROGRESS" || !file?.dzistatus) && file?.uploadStatus === "COMPLETED") && (
                                                                                                        <span className="material-symbols-outlined img_view loadingIcon"><img src={progessIcon} alt="" /></span>
                                                                                                    )}
                                                                                                    {file?.uploadStatus === "COMPLETED" && file?.dzistatus === "COMPLETED" && (
                                                                                                        <span
                                                                                                            title="Share Image"
                                                                                                            style={{ position: "absolute", top: "4px", right: "4px", cursor: "pointer", zIndex: 10, background: "rgba(255,255,255,0.85)", borderRadius: "50%", width: "22px", height: "22px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                handleShareClick(file);
                                                                                                            }}
                                                                                                        >
                                                                                                            <span className="material-symbols-outlined" style={{ fontSize: "13px", color: "#1E222B", fontWeight: 700 }}>share</span>
                                                                                                        </span>
                                                                                                    )}

                                                                                                </div>

                                                                                            </div>
                                                                                        );
                                                                                    })

                                                                                    :
                                                                                    noImageComponent()
                                                                                }



                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row col-lg-12 mt-0 upload-imgs">

                                                                    {/* <div className="d-flex col-lg-12 align-items-start justify-content-between upload-img-section pe-0 me-0">
                                                                        <label className="form_label col-3"></label>
                                                                        <p className="mt-0 mb-0 text-muted col-8 file-format">Note: Max File size: 2GB, Max files: 10 | Formats: TIF,TIFF</p>
                                                                    </div> */}
                                                                    {/* {editUser?.files?.length > 0 ?
                                                                        editUser.files.filter(file => getExtension(file?.originalFilename) === ".tif,.tiff").map.length > 0 &&

                                                                         */}
                                                                    <div className="d-flex justify-content-between">
                                                                        <p className="case-type-text">TIFF Files</p>
                                                                    </div>

                                                                    {/*                                                                         
                                                                        : noImageComponent()} */}


                                                                    {imagesUrls &&
                                                                        Object.keys(imagesUrls).length > 0 &&
                                                                        Object.keys(imagesUrls).filter(file =>
                                                                            [".tif", ".tiff"].includes(getExtension(imagesUrls[file].name))
                                                                        ).length > 0 && (
                                                                            <div className="d-flex justify-content-between">
                                                                                <p className="case-type-text">TIFF Files</p>
                                                                            </div>
                                                                        )
                                                                    }



                                                                    <div className="d-flex justify-content-start col-lg-12 histology-photo-section gap-2">

                                                                        <div className="mb-3 mt-2 input-field deep-zoom-styles">
                                                                            {/* OME Upload box */}

                                                                            {imagesUrls &&
                                                                                Object.keys(imagesUrls).length > 0 &&
                                                                                Object.keys(imagesUrls).filter((file) => getExtension(imagesUrls[file].name) === ".tif,.tiff").map((item, key) => (
                                                                                    <div className={`upload_images d-flex gap-2 align-items-start ${!item?.thumbnailUrl ? 'upload-static-img' : ''}`} key={key}>
                                                                                        <div className="img">
                                                                                            {item?.thumbnailUrl}
                                                                                            {/* <p className="text-truncate small mb-0">{imagesUrls[item].name}</p> */}
                                                                                            <span className={`default-img ${!item?.thumbnailUrl ? 'default-static-img' : ''}`}><img src={item?.thumbnailUrl ? `${imageCloudfront}${item?.thumbnailUrl?.replace(/ /g, '%20')}?auto=compress,format` : deepZoom} alt="" /></span>

                                                                                        </div>


                                                                                    </div>
                                                                                ))}


                                                                            {editUser?.files?.length > 0 ?
                                                                                editUser.files.filter(file => getExtension(file?.originalFilename) === ".tif,.tiff").map((file, key) => (
                                                                                    <div className={`upload_images d-flex gap-2 align-items-start ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`} key={key}>
                                                                                        <div
                                                                                            className="img cursor-pointer"
                                                                                            onClick={(e) => {
                                                                                                if (file?.dzistatus == "COMPLETED") {
                                                                                                    setPopupOpen(true);
                                                                                                    setImageDimensions({ width: file.width, height: file.height });

                                                                                                    let path = file.dziUrl || "";
                                                                                                    if (path.startsWith("/")) path = path.slice(1);
                                                                                                    let isDziURL = path.includes("output.dzi");
                                                                                                    if (isDziURL) {
                                                                                                        path = `${path}_files/`;
                                                                                                    }

                                                                                                    setDziUrl(imageCloudfront + path);
                                                                                                    setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                    setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                    handlePopupload(e);

                                                                                                    const viewableFiles = (editUser?.files || []).filter(f =>
                                                                                                        f.uploadStatus === "COMPLETED" &&
                                                                                                        getExtension(f?.originalFilename) === ".tif,.tiff" &&
                                                                                                        String(f.dzistatus).toUpperCase() === "COMPLETED"
                                                                                                    );
                                                                                                    const clickedIdx = viewableFiles.findIndex(f =>
                                                                                                        (f.fileid && f.fileid === file.fileid) || f.sourcepath === file.sourcepath
                                                                                                    );
                                                                                                    setDziImageList(viewableFiles);
                                                                                                    setDziCurrentIndex(clickedIdx >= 0 ? clickedIdx : 0);
                                                                                                }
                                                                                            }}
                                                                                        >

                                                                                            <span className={`default-img ${!file?.thumbnailUrl ? 'default-static-img' : ''}`}><img src={file?.thumbnailUrl ? `${imageCloudfront?.replace(/\/$/, "")}${file?.thumbnailUrl.replace(/ /g, '%20')}?auto=compress,format&width=150` : deepZoom} alt={file?.originalFilename} /></span>

                                                                                            {/* {!checkStuckUploads(file) && file?.dzistatus == "INPROGRESS" && <span className="material-symbols-outlined img_view deep-zzom-ope-icon progessIcon"><img src={progessIcon} alt="" /></span>}
                                                                                            
                                                                                            {checkStuckUploads(file) && <a onClick={(e) => handleImageFileDelete(e, file, key, "ome")} className="material-symbols-outlined img_view deep-zzom-ope-icon text-danger action-button"><span className="material-symbols-outlined img_view font-size-20">
                                                                                                close
                                                                                            </span></a>}


                                                                                            {file?.uploadStatus == "COMPLETED" && <span className="material-symbols-outlined img_view deep-zzom-ope-icon doneIcon">check</span>}


                                                                                            {file?.dzistatus == "INPROGRESS" && <span className="material-symbols-outlined img_view loadingIcon"><img src={loadingIcon} alt="" /></span>}
 */}

                                                                                            {/* {!checkStuckUploads(file) && file?.uploadStatus === "INPROGRESS" && (
                                                                                                <span className="img_view deep-zzom-ope-icon progessIcon">
                                                                                                    <img src={progessIcon} alt="Upload in progress" />
                                                                                                </span>
                                                                                            )} */}

                                                                                            {/* 

                                                                                            {file?.uploadStatus === "COMPLETED" && (
                                                                                                <span className="material-symbols-outlined img_view deep-zzom-ope-icon doneIcon">check</span>
                                                                                            )}

                                                                                            {file?.dzistatus === "INPROGRESS" && (
                                                                                                <span className="material-symbols-outlined img_view loadingIcon"><img src={loadingIcon} alt="" /></span>
                                                                                            )} */}

                                                                                            {file?.uploadStatus !== "COMPLETED" && !file?.dzistatus && (
                                                                                                <span className="material-symbols-outlined img_view loadingIcon"><img src={loadingIcon} alt="" /></span>
                                                                                            )}
                                                                                            {((file?.dzistatus === "INPROGRESS" || !file?.dzistatus) && file?.uploadStatus === "COMPLETED") && (
                                                                                                <span className="material-symbols-outlined img_view loadingIcon"><img src={progessIcon} alt="" /></span>
                                                                                            )}
                                                                                            {file?.uploadStatus === "COMPLETED" && file?.dzistatus === "COMPLETED" && (
                                                                                                <span
                                                                                                    title="Share Image"
                                                                                                    style={{ position: "absolute", top: "4px", right: "4px", cursor: "pointer", zIndex: 10, background: "rgba(255,255,255,0.85)", borderRadius: "50%", width: "22px", height: "22px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleShareClick(file);
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="material-symbols-outlined" style={{ fontSize: "13px", color: "#1E222B", fontWeight: 700 }}>share</span>
                                                                                                </span>
                                                                                            )}

                                                                                        </div>

                                                                                    </div>
                                                                                )) :



                                                                                noImageComponent()}

                                                                            {/* {editUser?.imageStatus == "INPROGRESS" && <div className="upload_images d-flex gap-2 align-items-start">
                                                                                        <div
                                                                                            className="img cursor-pointer">
                                                                                <img src={rotateIconorange} className="loading-icon" id="OtpLoginLoading" /></div></div>} */}

                                                                        </div>


                                                                    </div>
                                                                </div>
                                                            </div>




                                                            <div>
                                                                {imageErrorFiles && imageErrorFiles.length > 0 && imageErrorFiles?.map((item, key) => {

                                                                    return (
                                                                        <div className="upload_images" key={key}>
                                                                            <div className="img">
                                                                                <img src={item?.url} />
                                                                                <p>{item?.error} </p>
                                                                            </div>
                                                                            {/* <span onClick={(e) => handleImageErrorDelete(e, item)} className="material-symbols-outlined icon"> delete </span> */}
                                                                        </div>

                                                                    )
                                                                })}
                                                            </div>

                                                        </div>


                                                        <div className="row col-lg-5 col-md-12 col-12 video-edit-section answer-with-explanation">

                                                            <b className="mb-2 answer-text">Answer with Explanation</b>

                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field youtube-input-resp">
                                                                    <label className="form_label">YOUTUBE VIDEO URL</label>
                                                                    <input id="youtube" disabled name="youtube" placeholder="Enter Youtube URL" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.youtube || "N/A"} />
                                                                    <span id="youtube-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{youtubeError}</span>
                                                                </div>
                                                            </div>


                                                            <div className="col-lg-12 col-md-12">
                                                                {
                                                                    getYouTubeVideoId(editUser?.youtube) && (
                                                                        <div style={{ marginTop: "10px" }}>
                                                                            <img
                                                                                src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                                                                                    editUser?.youtube
                                                                                )}/0.jpg`}
                                                                                alt="YouTube Thumbnail"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    maxWidth: "300px",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() => setShowVideoPopup(true)}
                                                                            />
                                                                            <p className="d-flex justify-content-start align-items-center gap-2"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => setShowVideoPopup(true)}
                                                                            >
                                                                                <span className="material-symbols-outlined">
                                                                                    smart_display
                                                                                </span> <span className="pre-vid-txt">Preview Video</span>
                                                                            </p>
                                                                        </div>)
                                                                }

                                                                {showVideoPopup && (
                                                                    <div
                                                                        style={{
                                                                            position: "fixed",
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            backgroundColor: "rgba(0,0,0,0.8)",
                                                                            zIndex: 1000,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                        }}
                                                                        onClick={() => setShowVideoPopup(false)}
                                                                    >
                                                                        <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                                                            <iframe
                                                                                width="100%"
                                                                                height="450"
                                                                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                                                    editUser?.youtube
                                                                                )}`}
                                                                                frameBorder="0"
                                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                allowFullScreen
                                                                                title="Video Preview"
                                                                                isDisabled
                                                                            ></iframe>



                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <style>
                                                                {
                                                                    `
                                                                textarea.form-control {
                                                                min-height: calc(6.5em + .75rem + 2px) !important;}
                                                                `
                                                                }
                                                            </style>
                                                            <div className="col-lg-12 col-md-12 answer-input-resp">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">EXPLANATION
                                                                    </label>

                                                                    <Editor name="editUser?.explanation" disabled={true} placeholder="Enter Explanation" className="edit-case-explanation" onChange={(e) => onExplanationChange(e)} value={editUser?.explanation || "N/A"} />


                                                                    <span id="explanation-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{explanationError}</span>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 answers-input">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Answer(1 point)
                                                                    </label>
                                                                    {filteredOptionsMap?.answer1 && <Select
                                                                        className="select"
                                                                        isMulti={false}
                                                                        placeholder="N/A"
                                                                        onChange={(option) => handleSelectChange(option, "answer1")}
                                                                        onInputChange={(value) => handleInputChange(value, "answer1")}
                                                                        options={filteredOptionsMap?.answer1}
                                                                        isClearable
                                                                        value={editUser?.answer1 || null}
                                                                        components={customComponents}
                                                                        isDisabled
                                                                    />}

                                                                    <span id="answer1-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{answer1Error}</span>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 answers-input">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Answer(1 point)
                                                                    </label>
                                                                    {filteredOptionsMap?.answer11 && <Select
                                                                        className="select"
                                                                        isMulti={false}
                                                                        placeholder="N/A"
                                                                        onChange={(option) => handleSelectChange(option, "answer11")}
                                                                        onInputChange={(value) => handleInputChange(value, "answer11")}
                                                                        options={filteredOptionsMap?.answer11}
                                                                        isClearable
                                                                        value={editUser?.answer11 || null}
                                                                        components={customComponents}
                                                                        isDisabled
                                                                    />}


                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 answers-input">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Answer(0.5 point) {id && <span className="required"></span>}</label>
                                                                    {filteredOptionsMap?.answer2 && <Select
                                                                        className="select"
                                                                        isMulti={false}
                                                                        placeholder="N/A"
                                                                        onChange={(option) => handleSelectChange(option, "answer2")}
                                                                        onInputChange={(value) => handleInputChange(value, "answer2")}
                                                                        options={filteredOptionsMap?.answer2}
                                                                        isClearable
                                                                        value={editUser?.answer2 || null}
                                                                        components={customComponents}
                                                                        isDisabled
                                                                    />}

                                                                    <span id="answer2-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{answer2Error}</span>


                                                                </div>
                                                            </div>
                                                            <hr />



                                                            {(editUser?.caseModules?.length > 0 || editUser?.caseModules === undefined) &&
                                                                <>
                                                                    <hr />
                                                                    <div className="col-lg-12 col-md-12 answers-input">

                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Assigned Modules</label>

                                                                            <ul>
                                                                                {editUser?.caseModules?.map((module, index) => (
                                                                                    <li className="nav-item" key={index}>{module}</li>
                                                                                ))}
                                                                            </ul>


                                                                        </div>
                                                                    </div></>

                                                            }

                                                        </div>



                                                    </div>




                                                </div>
                                                <div className="line">

                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 d-flex" >




                                                    {/* {id && <button id="submit-button" className={editUser?.files && editUser?.files.length > 0 ? "fill-btn-style create-quiz-btn border-0" : "fill-btn-style create-quiz-btn border-0 disabled"} type="button" onClick={e => handleUpdate(e, 'ACTIVE')} 
                                                    disabled={editUser?.files && editUser?.files.length > 0 ?  false : true}
                                                        >Save
                                                    </button>} */}

                                                    {/* {(completedFiles && editUser?.files && (completedFiles?.length == editUser?.files.length) && editUser?.status == "INACTIVE") && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleUpdate(e, 'ACTIVE')} >Save
                                                    </button>} */}


                                                    {/* {(editUser?.status == "ACTIVE") && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleUpdate(e, 'ACTIVE')} >Save
                                                    </button>} */}


                                                    {/* {id === undefined && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleAddUser(e, 'INACTIVE')}>Save as draft
                                                    </button>} */}

                                                </div>
                                                {/* {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>} */}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Footer id="footer" />
                    </div>

                }


                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed", top: 0, left: 0,
                            width: "100%", height: "100%",
                            backgroundColor: "rgba(0,0,0,0.88)",
                            zIndex: 1003, display: "flex", flexDirection: "column",
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        {/* Header */}
                        <div
                            style={{
                                display: "flex", justifyContent: "space-between", alignItems: "center",
                                padding: "0 20px", height: "52px", flexShrink: 0,
                                background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                                borderBottom: "1px solid rgba(255,255,255,0.08)",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{ width: "120px" }} />
                            {clinicalPopupList.length > 1 ? (
                                <div style={{
                                    display: "flex", alignItems: "center",
                                    background: "rgba(255,255,255,0.07)",
                                    border: "1px solid rgba(255,255,255,0.15)",
                                    borderRadius: "30px", padding: "3px",
                                }}>
                                    <button
                                        onClick={() => navigateClinicalImage(clinicalPopupIndex - 1)}
                                        disabled={clinicalPopupIndex === 0}
                                        title="Previous image (←)"
                                        style={{
                                            border: "none",
                                            background: clinicalPopupIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)",
                                            color: clinicalPopupIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                            cursor: clinicalPopupIndex === 0 ? "not-allowed" : "pointer",
                                            width: "34px", height: "34px", borderRadius: "50%",
                                            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                    </button>
                                    <span style={{
                                        display: "flex", alignItems: "center", gap: "4px",
                                        padding: "0 12px", fontSize: "13px", fontWeight: "600",
                                        userSelect: "none", whiteSpace: "nowrap",
                                    }}>
                                        <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{clinicalPopupIndex + 1}</span>
                                        <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                        <span style={{ color: "rgba(255,255,255,0.6)" }}>{clinicalPopupList.length}</span>
                                    </span>
                                    <button
                                        onClick={() => navigateClinicalImage(clinicalPopupIndex + 1)}
                                        disabled={clinicalPopupIndex === clinicalPopupList.length - 1}
                                        title="Next image (→)"
                                        style={{
                                            border: "none",
                                            background: clinicalPopupIndex === clinicalPopupList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)",
                                            color: clinicalPopupIndex === clinicalPopupList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                            cursor: clinicalPopupIndex === clinicalPopupList.length - 1 ? "not-allowed" : "pointer",
                                            width: "34px", height: "34px", borderRadius: "50%",
                                            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                    </button>
                                </div>
                            ) : <div />}
                            <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                                <button
                                    className="dz_close"
                                    onClick={() => setShowImagePopup(false)}
                                    title="Close"
                                    style={{
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        background: "rgba(255,255,255,0.07)",
                                        color: "#ffffff", borderRadius: "50%",
                                        width: "34px", height: "34px",
                                        display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                                    }}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                                </button>
                            </div>
                        </div>
                        {/* Image area */}
                        <div
                            style={{
                                flex: 1, position: "relative",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                padding: "20px", overflow: "hidden",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {isClinicalLoading && (
                                <div style={{
                                    position: "absolute", inset: 0,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                                }}>
                                    <div style={{
                                        width: "52px", height: "52px", borderRadius: "50%",
                                        border: "4px solid rgba(255,255,255,0.15)",
                                        borderTopColor: "#EA7F4A",
                                        animation: "dz-spin 0.75s linear infinite",
                                    }} />
                                    <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                                </div>
                            )}
                            <img
                                src={popupImage}
                                onLoad={() => setIsClinicalLoading(false)}
                                onError={() => setIsClinicalLoading(false)}
                                style={{
                                    maxWidth: "100%", maxHeight: "100%",
                                    objectFit: "contain", display: "block", borderRadius: "4px",
                                    opacity: isClinicalLoading ? 0 : 1,
                                    transition: "opacity 0.2s ease",
                                }}
                            />
                        </div>
                    </div>


                )}

            </div>



            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={dzipopupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 20px",
                                height: "52px",
                                background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                                borderBottom: "1px solid rgba(255,255,255,0.08)",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                            }}>
                                <div style={{ width: "120px" }} />

                                {dziImageList.length > 1 ? (
                                    <div style={{
                                        display: "flex", alignItems: "center",
                                        background: "rgba(255,255,255,0.07)",
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        borderRadius: "30px", padding: "3px",
                                    }}>
                                        <button
                                            onClick={() => navigateDziImage(dziCurrentIndex - 1)}
                                            disabled={dziCurrentIndex === 0}
                                            title="Previous image (←)"
                                            style={{
                                                border: "none",
                                                background: dziCurrentIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)",
                                                color: dziCurrentIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                                cursor: dziCurrentIndex === 0 ? "not-allowed" : "pointer",
                                                width: "34px", height: "34px", borderRadius: "50%",
                                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                        </button>
                                        <span style={{
                                            display: "flex", alignItems: "center", gap: "4px",
                                            padding: "0 12px", fontSize: "13px", fontWeight: "600",
                                            userSelect: "none", whiteSpace: "nowrap",
                                        }}>
                                            <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{dziCurrentIndex + 1}</span>
                                            <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                            <span style={{ color: "rgba(255,255,255,0.6)" }}>{dziImageList.length}</span>
                                        </span>
                                        <button
                                            onClick={() => navigateDziImage(dziCurrentIndex + 1)}
                                            disabled={dziCurrentIndex === dziImageList.length - 1}
                                            title="Next image (→)"
                                            style={{
                                                border: "none",
                                                background: dziCurrentIndex === dziImageList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)",
                                                color: dziCurrentIndex === dziImageList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                                cursor: dziCurrentIndex === dziImageList.length - 1 ? "not-allowed" : "pointer",
                                                width: "34px", height: "34px", borderRadius: "50%",
                                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                        </button>
                                    </div>
                                ) : <div />}

                                <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        title="Close"
                                        style={{
                                            border: "1px solid rgba(255,255,255,0.15)",
                                            background: "rgba(255,255,255,0.07)",
                                            color: "#ffffff", borderRadius: "50%",
                                            width: "34px", height: "34px",
                                            display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {isDziLoading && (
                                    <div style={{
                                        position: "absolute", inset: 0,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                                    }}>
                                        <div style={{
                                            width: "52px", height: "52px", borderRadius: "50%",
                                            border: "4px solid rgba(255,255,255,0.15)",
                                            borderTopColor: "#EA7F4A",
                                            animation: "dz-spin 0.75s linear infinite",
                                        }} />
                                        <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                                    </div>
                                )}

                                <div
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        color: "grey",
                                        fontSize: "2vw",
                                        fontWeight: "600",
                                        textTransform: "uppercase",
                                        letterSpacing: "2px",
                                        textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
                                        pointerEvents: "none",
                                        zIndex: 10,
                                        userSelect: "none"
                                    }}
                                >
                                    Copyright © 2026 DADI
                                </div>

                                {/* Instructions */}
                                {/* <div style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "12px"
                            }}>
                                <p style={{ margin: "2px 0" }}>â€¢ Zoom with mouse wheel or pinch gesture</p>
                                <p style={{ margin: "2px 0" }}>â€¢ Pan by clicking and dragging</p>
                                <p style={{ margin: "2px 0" }}>â€¢ Use the navigator in the bottom-right for orientation</p>
                                <p style={{ margin: "2px 0" }}>â€¢ Use toolbar buttons to rotate or reset view</p>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>â€¢ Zoom with mouse wheel or pinch gesture</p>
                            <p>â€¢ Pan by clicking and dragging</p>
                            <p>â€¢ Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}


            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {/* <SweetAlert
                show={uploadImg}
                title={"File Uploading......"}
                showConfirm={false} // Hides the OK button
            ></SweetAlert> */}


            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={UpdateSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onUpdateConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={alertPopup}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Maximum 10 files allowed"
                focusCancelBtn
                onConfirm={e => setAlertPopup(false)}
            >
            </SweetAlert>

            <SweetAlert
                show={uploadImg}
                showConfirm={false}
                title=""
            //  onConfirm={() => setAlert(null)}
            >
                <div className="d-flex flex-column align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">File Uploading...</span>
                    </div>
                    <p className="mt-3">File is Uploading...</p>
                </div>
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>
            {/* {editUser?.files && <FileUploadChecker files={editUser.files} />} */}

            {/* Share Image Modal */}
            <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered enforceFocus={false} dialogClassName="share-modal-narrow">
                <Modal.Header closeButton closeVariant="white" style={{ backgroundColor: "#1E222B", borderBottom: "1px solid #333" }}>
                    <Modal.Title style={{ color: "#fff", fontSize: "16px", display: "flex", alignItems: "center", gap: "8px" }}>
                        <span className="material-symbols-outlined" style={{ color: "#F2A341", fontSize: "22px" }}>share</span>
                        Share Histology Image
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "24px" }}>
                    {shareUrl ? (
                        <div>
                            <div className="d-flex align-items-center gap-2 mb-3 p-3" style={{ background: "rgba(34,197,94,0.08)", borderRadius: "8px", border: "1px solid rgba(34,197,94,0.3)" }}>
                                <span className="material-symbols-outlined" style={{ color: "#22c55e", fontSize: "20px" }}>check_circle</span>
                                <div>
                                    <p className="mb-0" style={{ fontWeight: 600, fontSize: "14px", color: "#166534" }}>Share link is active!</p>
                                    {shareExpiresAt && (
                                        <p className="mb-0" style={{ fontSize: "12px", color: "#555" }}>
                                            Expires: {new Date(shareExpiresAt).toLocaleString()}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <p className="text-muted mb-2" style={{ fontSize: "13px" }}>Share link:</p>
                            <input
                                type="text"
                                className="form-control mb-3"
                                value={shareUrl}
                                readOnly
                                style={{ fontSize: "13px", backgroundColor: "#f8f9fa" }}
                            />
                            <div className="d-flex gap-2">
                                <button
                                    className="btn w-50"
                                    style={{ backgroundColor: "#1E222B", color: "#fff", border: "none", borderRadius: "6px", fontWeight: 600, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                                    onClick={handleCopyShareUrl}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>content_copy</span>
                                    Copy Link
                                </button>
                                <button
                                    className="btn w-50"
                                    style={{ backgroundColor: "#25D366", color: "#fff", border: "none", borderRadius: "6px", fontWeight: 600, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                                    onClick={handleWhatsAppShare}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                                    WhatsApp
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {shareFile && (
                                <div className="d-flex align-items-center gap-2 mb-4 p-3" style={{ background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <span className="material-symbols-outlined" style={{ color: "#F2A341", fontSize: "20px" }}>image</span>
                                    <span style={{ fontSize: "13px", color: "#555", fontWeight: 500 }}>{shareFile?.originalFilename || shareFile?.filename || "Histology Image"}</span>
                                </div>
                            )}
                            <p className="mb-2" style={{ fontWeight: 600, fontSize: "14px", color: "#1E222B" }}>Set expiry date &amp; time</p>
                            <p className="text-muted mb-3" style={{ fontSize: "13px" }}>This link will automatically expire at the selected date and time.</p>
                            <div className="mb-3">
                                <label className="form-label" style={{ fontSize: "13px", fontWeight: 600, color: "#444" }}>Expires On</label>
                                <ThemeProvider theme={orangeTheme}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            value={shareExpiryAt}
                                            onChange={(newValue) => setShareExpiryAt(newValue)}
                                            disablePast
                                            format="DD/MM/YYYY hh:mm A"
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    size: "small",
                                                    placeholder: "Select date and time",
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </ThemeProvider>
                                <div className="d-flex flex-wrap gap-2 mt-2">
                                    {[{ label: "6 hours", h: 6 }, { label: "12 hours", h: 12 }, { label: "1 day", h: 24 }, { label: "3 days", h: 72 }, { label: "1 week", h: 168 }].map((preset) => {
                                        const isActive = shareExpiryAt && shareExpiryAt.isValid() && Math.abs(shareExpiryAt.diff(dayjs().add(preset.h, 'hour'), 'minute')) < 1;
                                        return (
                                            <button
                                                key={preset.h}
                                                type="button"
                                                onClick={() => setShareExpiryAt(dayjs().add(preset.h, 'hour'))}
                                                style={{
                                                    fontSize: "12px", fontWeight: 600, padding: "4px 12px", borderRadius: "20px", cursor: "pointer",
                                                    border: isActive ? "1.5px solid #F2A341" : "1px solid #ddd",
                                                    background: isActive ? "#fff3e0" : "#fff",
                                                    color: isActive ? "#d97706" : "#555",
                                                }}
                                            >
                                                {preset.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                            {isShareExpiryValid && (
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "linear-gradient(135deg, #fff8ee 0%, #fff3e0 100%)", border: "1.5px solid #F2A341", borderRadius: "8px", padding: "10px 14px", marginBottom: "14px" }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: "22px", color: "#F2A341", flexShrink: 0 }}>schedule</span>
                                    <div>
                                        <div style={{ fontSize: "11px", fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", lineHeight: 1 }}>Link expires</div>
                                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#d97706", marginTop: "2px" }}>
                                            {shareExpiryAt.format("DD MMM YYYY, hh:mm A")}
                                        </div>
                                        <div style={{ fontSize: "12px", fontWeight: 600, color: "#b45309", marginTop: "1px" }}>
                                            {getShareExpiryCountdown()}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button
                                className="btn w-100 mt-1"
                                style={{
                                    backgroundColor: "#F2A341",
                                    color: "#fff",
                                    border: "none", borderRadius: "6px", fontWeight: 700, fontSize: "14px", padding: "10px",
                                    cursor: isShareExpiryValid && !shareGenerating ? "pointer" : "not-allowed",
                                    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                                    opacity: isShareExpiryValid && !shareGenerating ? 1 : 0.45,
                                }}
                                disabled={!isShareExpiryValid || shareGenerating}
                                onClick={handleGenerateShareUrl}
                            >
                                {shareGenerating ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Generating...
                                    </>
                                ) : (
                                    <>
                                        <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>link</span>
                                        Generate Share Link
                                    </>
                                )}
                            </button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

        </>
    );
};

export default ViewLearningCase;